var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceAndTechnologyMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3880.000000, -906.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device-and-technology/Mobile-",
    transform: "translate(3880.000000, 906.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,0 L26,28 C26,30.209 24.209,32 22,32 L22,32 L6,32 L6,4 C6,1.791 7.791,0 10,0 L10,0 L26,0 Z M16.5,27 C15.671,27 15,27.672 15,28.5 C15,29.328 15.671,30 16.5,30 C17.328,30 18,29.328 18,28.5 C18,27.672 17.328,27 16.5,27 Z M23,3.999 L9,3.999 L9,26 L23,26 L23,3.999 Z M19.2499,14 C19.6649,14 19.9999,14.336 19.9999,14.75 L19.9999,14.75 L19.9999,16.25 C19.9999,16.664 19.6649,17 19.2499,17 L19.2499,17 L17.7499,17 C17.3359,17 16.9999,16.664 16.9999,16.25 L16.9999,16.25 L16.9999,14.75 C16.9999,14.336 17.3359,14 17.7499,14 L17.7499,14 Z M19.2499,8 C19.6649,8 19.9999,8.336 19.9999,8.75 L19.9999,8.75 L19.9999,10.25 C19.9999,10.664 19.6649,11 19.2499,11 L19.2499,11 L17.7499,11 C17.3359,11 16.9999,10.664 16.9999,10.25 L16.9999,10.25 L16.9999,8.75 C16.9999,8.336 17.3359,8 17.7499,8 L17.7499,8 Z M14.2499,8 C14.6649,8 14.9999,8.336 14.9999,8.75 L14.9999,8.75 L14.9999,10.25 C14.9999,10.664 14.6649,11 14.2499,11 L14.2499,11 L12.7499,11 C12.3359,11 11.9999,10.664 11.9999,10.25 L11.9999,10.25 L11.9999,8.75 C11.9999,8.336 12.3359,8 12.7499,8 L12.7499,8 Z",
    id: 138
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceAndTechnologyMobile);
export default __webpack_public_path__ + "static/media/device-and-technology-mobile.29d6acf0.svg";
export { ForwardRef as ReactComponent };